module.exports = __webpack_public_path__ + "static/media/gallery-bg.a51c03ea.jpg";